var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feedback-table',{attrs:{"kind":"misconduct","title":"Misconduct"}})
}
var staticRenderFns = []

export { render, staticRenderFns }